/**
 * Created by mateimisarca on 20.03.2021
 */

export const ROLES = {
  USER: 'user',
  ADMIN: 'admin',
  SUPER_ADMIN: 'superAdmin',
};
